import { OperatorStudios } from './OperatorStudios'

export default OperatorStudios
